<template>
  <v-container class="RivalSubMenu">

    <div style="padding: 10px;" >

      <a  style="text-decoration: none;" href="https://survey123.arcgis.com/share/c8fe586abec24417ad53a1768f8246a2?portalUrl=https://map.lpn.co.th/portal" target="_blank">

        <v-card
            v-ripple
            class="mx-auto "
            height="90"
            style="border-radius: 10px;"
            color="primary"

        >
          <v-card-actions>
            <v-list-tile class="grow">
              <v-list-tile-avatar tile>
                <v-img  :src="require(`@/assets/img/ic-survey.png`)"  ></v-img>
              </v-list-tile-avatar>
              <v-list-tile-content >
                 <span class="title font-weight-bold text-wrap " style="color: white;">
                  สำรวจคู่แข่ง <br>Competitor Survey
                </span>
              </v-list-tile-content>

            </v-list-tile>
          </v-card-actions>

        </v-card>

      </a>

    </div>

    <div style="padding: 10px;" >

      <a  style="text-decoration: none;" href="https://map.lpn.co.th/portal/apps/experiencebuilder/experience/?data_id=dataSource_1-LPNMAP_Competitor_5919%3A8&id=7d3a328d79724f23956b27b62c58bdb0&page=page_3" target="_blank">

        <v-card
            v-ripple
            class="mx-auto "
            height="90"
            style="border-radius: 10px;"
            color="primary"

        >
          <v-card-actions>
            <v-list-tile class="grow">
              <v-list-tile-avatar tile>
                <v-img  :src="require(`@/assets/img/ic-report.png`)"  ></v-img>
              </v-list-tile-avatar>
              <v-list-tile-content>

                <span class="title font-weight-bold text-wrap " style="color: white;">
                 รายงานสำรวจ <br>Survey Report
                </span>
              </v-list-tile-content>
            </v-list-tile>
          </v-card-actions>

        </v-card>

      </a>

    </div>

  </v-container>
</template>

<script>
import EventBus from '@/EventBus'
export default {
  name: "RivalSubMenu",
  mounted() {
    EventBus.$emit('set_navigation', {title: 'สำรวจคู่แข่ง',back_route: 'home'});

  }
}
</script>

<style scoped>
.hide-div{
  display: none;
}

.div-sub-menu{
  margin-left: 20px;
}
</style>